<template>
    <div class="g-footer">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name:'GvuiFooter'
}
</script>
<style lang="scss" scoped>

</style>

